import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SafeBg from '@/components/shared/SafeBg';
import IdolAvatar from '@/components/ui/IdolAvatar';
import placeholder_portrait_70x70 from '@/assets/imgs/placeholders/portrait_70x70.jpg';
import placeholder_cover_1600x700 from '@/assets/imgs/placeholders/cover_1600x700.jpg';

/**
 * 偶像封面卡：封面底圖 + 漸層遮罩 + 頭像 + 名稱
 * - 名稱單行截斷（text-truncate），官方認證勾勾恆顯示（flex-shrink-0 不被裁）
 * - 共用於 MyIdol（首頁個人卡）、IdolsRecommend（推薦）、FollowedIdols（關注 tab）、AppNavbar 帳號下拉
 * - 外距等差異由 className 吸收（如 mb-4 / mb-3 / mb-2）
 * - 有 href 時自身包 <a>；無 href 時只渲染卡片（供外層如 Dropdown.Item 自帶連結，避免巢狀 <a>）
 * - 有 idolId 時頭像顯示在線綠點（推薦、關注 tab）；MyIdol、AppNavbar 是自己的偶像，不傳
 * - 名稱疊在封面上，維持 fs-18 白字（docs/idol-online-plan.md §5.3 的例外），只統一勾勾間距 gap-1
 */
const IdolCoverCard = ({ coverUrl, avatarUrl, nickName, isOfficial, idolId, href, className = '' }) => {
  const card = (
    <SafeBg
      src={coverUrl || placeholder_cover_1600x700}
      className="border rounded shadowA position-relative overflow-hidden"
      style={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div
        className="position-absolute w-100 d-flex align-items-center justify-content-center"
        style={{
          background: 'linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.4))',
          height: '50%',
          top: '25%',
        }}
      >
      </div>
      <div className="d-flex gap-2 align-items-center position-relative p-3" style={{ zIndex: 2 }}>
        <IdolAvatar
          size="md2"
          src={avatarUrl || placeholder_portrait_70x70}
          idolId={idolId}
          className="mb-2"
          imgClassName="border border-white"
          alt={nickName}
        />
        <p className="fs-18 mb-0 fw-semibold text-white d-flex align-items-center gap-1 min-w-0">
          <span className="text-truncate min-w-0">{nickName}</span>
          {isOfficial && (
            <FontAwesomeIcon
              icon="fa-solid fa-circle-check"
              className="text-primary flex-shrink-0"
            />
          )}
        </p>
      </div>
    </SafeBg>
  );

  if (href) {
    return (
      <a href={href} className={`link-none hover-p d-block ${className}`}>
        {card}
      </a>
    );
  }

  return <div className={`d-block ${className}`}>{card}</div>;
};

IdolCoverCard.propTypes = {
  coverUrl: PropTypes.string,
  avatarUrl: PropTypes.string,
  nickName: PropTypes.string,
  isOfficial: PropTypes.bool,
  idolId: PropTypes.number,
  href: PropTypes.string,
  className: PropTypes.string,
};

export default IdolCoverCard;
